// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2NXLs","colMin":"styles_colMin__2wE2_","colCheckbox":"styles_colCheckbox__kkrpD"};